/**
 * handoff.js — Mini App → real-browser capture hand-off.
 *
 * getUserMedia is blocked in the Telegram webview, so punching happens in a
 * real browser page. From the Mini App we mint a single-use punch token
 * (initData-authed) and hand off to that page via WebApp.openLink, carrying the
 * token in the URL. The browser page (CaptureScreen) does GPS + camera + the
 * actual web_punch.
 */
import api from './api.js';

// The public capture page. Override via VITE_CAPTURE_URL for staging.
export const CAPTURE_URL =
  import.meta.env.VITE_CAPTURE_URL || 'https://davomat.oneplusone.uz/capture';

/**
 * startBrowserPunch({ direction, branch_id?, tg })
 *   1. POST punch_token{direction, branch_id?}  (initData-authed)
 *   2. openLink(CAPTURE_URL?t=<token>)          (real browser, has getUserMedia)
 * Returns the punch_token result ({ok,token,ttl} | {ok:false,error}); the caller
 * surfaces any error. On success the Mini App stays on Landing while the worker
 * finishes in the browser and returns to Telegram.
 */
export async function startBrowserPunch({ direction, branch_id, tg }) {
  if (tg && tg.haptic) tg.haptic('selection');
  const res = await api.punchToken({ direction, branch_id });
  if (!res || !res.ok || !res.token) {
    return res && res.error ? res : { ok: false, error: 'SERVER_ERROR' };
  }
  const url = `${CAPTURE_URL}?t=${encodeURIComponent(res.token)}`;
  try {
    if (window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.openLink) {
      window.Telegram.WebApp.openLink(url);
    } else {
      window.open(url, '_blank');
    }
  } catch (_e) {
    return { ok: false, error: 'SERVER_ERROR' };
  }
  return res;
}
